/* eslint-disable
    max-len,
    no-unused-vars,
    no-useless-escape,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./confirmDialog.scss');

const deps = [require('ui/web/modal').name];

module.exports = angular
  .module('bench.component.confirmDialog', deps)

  .directive('blConfirm', blConfirmService => ({
    /* Simple confirm
     * bl-confirm="a message" will execute your expression
     * bl-confirm-{success/failure} will be an expression that's run on confirm or cancellation
     * ie. bl-confirm-success='fn()'
     * bl-confirm-primary="Confirm" or "Okay" or w/e
     * bl-confirm-cancel="Cancel" or "No"
     * bl-confirm-icon="bl-icon-trash" - alternative icon
     */
    restrict: 'A',
    link(scope, elem, attrs) {
      return elem.bind('click', e =>
        scope.$apply(() => {
          const message = attrs.blConfirm;
          const confirmText = attrs.blConfirmPrimary || 'Confirm';
          const cancelText = attrs.blCancelPrimary || 'Cancel';
          const template = attrs.blConfirmTemplate;

          let iconMarkup = '';
          let titleMarkup = '';

          if (attrs.blConfirmIcon) {
            iconMarkup = `<span class=\"bl-icon-${attrs.blConfirmIcon} ngdialog-icon\"></span>`;
          }

          if (attrs.blConfirmTitle) {
            titleMarkup = `<h2 class=\"ngdialog-title\">${attrs.blConfirmTitle}</h2>`;
          }

          if (scope.$eval(attrs.blConfirmDisabled)) {
            if (attrs.blConfirmSuccess != null) {
              scope.$eval(attrs.blConfirmSuccess);
            }
          } else {
            blConfirmService
              .openConfirm(message, iconMarkup, titleMarkup, template, confirmText, cancelText)
              .then(
                () => {
                  if (attrs.blConfirmSuccess != null) {
                    return scope.$eval(attrs.blConfirmSuccess);
                  }
                },
                () => {
                  if (attrs.blConfirmFailure != null) {
                    return scope.$eval(attrs.blConfirmFailure);
                  }
                },
              );
          }
          return false;
        }),
      );
    },
  }))
  .service('blConfirmService', ngDialog => ({
    openConfirm(
      message,
      iconMarkup = '',
      titleMarkup = '',
      template,
      confirmText = 'Confirm',
      cancelText = 'Cancel',
      showCancel = true,
    ) {
      return ngDialog.openConfirm({
        className: 'bl-confirm',
        plain: true, // use plain string as template
        appendTo: '[ng-app]',
        template:
          template ||
          `\
<div class="bl-card">
  <div class="bl-card_section bl-card_section-padded-medium">
    ${iconMarkup}
    ${titleMarkup}
    <p class="ngdialog-text">${message}</p>
  </div>
  <div class="bl-card_section_bottom">
    <div class="ngdialog-buttons">
      <button
        class="bl-button danger"
        ng-class="{full: ${!showCancel}}"
        ng-click="confirm(1)"
        data-test-id="confirm-dialog-confirm"
      >
        ${confirmText}
      </button>
      <button
        class="bl-button secondary"
        ng-click="closeThisDialog(0)"
        ng-if="${showCancel}"
        data-test-id="confirm-dialog-cancel"
      >
        ${cancelText}
      </button>
    </div>
  </div>
</div>\
`,
      });
    },
  }));
